export const DIALING_CODE = '+91';

export const NAVIGATION_ROUTES = {
  REFERRAL_HOME: '/',
  REFERRAL_REFERRAL: '/referral',
  REFERRAL_VIDEO: '/video',
  REFERRAL_MY_EARNINGS: '/my-earnings',
  REFERRAL_LOGIN: '/login',
  REFERRAL_SIGNUP: '/signup',
  REFERRAL_PENDINGS: '/referral-pendings',
  REFERRAL_PAYOUT_HISTORY: '/payout-history',
  REFERRAL_OTP: '/otp',
  REFERRAL_KYC: '/kyc',
  REFERRAL_EXTERNAL_LINKS: '/external-links',
  REFERRAL_TNC: 'https://watchvertical.co/terms-and-conditions/',
  //REFERRAL_TNC: '/terms-and-conditions',
  REFERRAL_FAQ: '/faq',
  REFERRAL_SUBSCRIPTION: '/subscription',
  REFERRAL_SUBSCRIBED: '/subscribed',
  REFERRAL_APP_DOWNLOAD: '/appdownload',
  REFERRAL_SUBSCRIPTION_PAYMENT: '/subscription-payment',
  REFERRAL_PAYMENT_FAILED: '/payment-failed',
  REFERRAL_SESSION_EXPIRE: '/session-expire',
}

export const API_ROUTES = {
  REFERRAL_GET_REFERRAL: '/v1.0/referral/influencer/getHomeScreen',
  REFERRAL_GET_INFLUENCER_EARNINGS: '/v1.0/referral/influencer/getEarningsScreen',
  REFERRAL_SEND_OTP: '/v1.0/user/requestSignupOtp',
  REFERRAL_GET_USER_DETAILS: '/v1.0/user/getUserDetails',
  GET_INFLUENCER_PAYOUT_COUNT: '/v1.0/referral/influencer/getPayoutCount',
  REFERRAL_GET_PASSBOOK_TRANSACTION_HISTORY: '/v1.0/wallet/referralSuperstar/passbook',
  REFERRAL_GET_PASSBOOK_TRANSACTION_HISTORY_FILTERS: '/v1.0/wallet/referralSuperstar/filters',
  REFERRAL_INITIATE_WITHDRAWAL: '/v1.0/payment/referralSuperstar/initiateWithdrawal',
  REFERRAL_INITIATE_PROCESSPAYMENT: '/v1.0/payment/referralSuperstar/processPayout',
  REFERRAL_FETCH_FTW_SCREEN_DATA: '/v1.0/payment/fetchFtwScreenData',
  REFERRAL_ADD_UPI: '/v1.0/user/addUpiId',
  REFERRAL_ADD_BANK: '/v1.0/payment/bank/submit',
  REFERRAL_PRE_AUTHENTICATE_USER: '/v1.0/config/preSignUp',
  REFERRAL_DEBOUNCE: '/v1.0/payment/referralSuperstar/debounceWithdrawal',
  // Kafka Events API (Super API)
  PUSH_KAFKA_EVENT: '/v1/pushEventsToKafka'
}

export const API_CONFIG = {
  REFERRAL_CALL_TIMEOUT: 10000,
}

export const DEFAULT_SPLASH_VIDEO_DETAILS = {
  backgroundColor: "#101A26",
};
export const EXPONENTIAL_BACKOFF = [1, 2, 5];
export const API_REQUEST_TIME_OUT = 15000;
export const NETWORK_ERROR = 'Network Error';
export const TIME_OUT_EXCEED = 'timeout';
export const USER_TOKEN = 'USER_TOKEN';
export const USER_PRESIGNUP = "USER_PRESIGNUP"
export const RETRY_COUNT = 0;
export const DEFAULT_NUMBER_VALIDATION = '^\\+91[6789]\\d{9}$';
export const LOGIN_INPUT_REGEX = /^(\+91\s?)|[^0-9]/g;
export const SIGN_UP_ACTION = 'SignUp';
export const MAIN_CLIENT = 'MAIN_CLIENT';
export const SIGN_IN_ACTION = 'SignIn';
export const RESENT_OTP_TIME = 30;
export const SKELETON_TIMEOUT = 1500;
export const TIMEOUT_FOR_ONE_SEC = 1000;
export const RUPEE_ICON = '₹';
export const RESEND_OTP_DEBOUNCE_DELAY = 0;
export const PARTNER_ID_KEY = 'PARTNER_ID';
export const GOOGLE_LOGIN_KEY = 'GOOGLE_LOGIN_KEY';
export const LANGUAGE = 'en';
export const CX_LANGUAGE = 'hi';
export const PARTNER_ID = 'PWA';
export const SIGNUP = 'SIGNUP';
export const LOGIN = 'LOGIN';
export const STALE_TIME = 30000;
export const INITIAL_PHONE_NUMBER_PREFIX = '+91';


export const SIGN_IN_CODES = {
  SUCCESS_CODE: '0000',
  INCORRECT_OTP: '2005',
  INVALID_REFRESH_TOKEN: '1005',
  SKIP_AUTHENTICATION_FAILED: '2007',
  EXISTING_USER_ERROR_CODE: '1013'
}
export const RJT = 'RJT'

export const PAYMENT_STEPS = {
  INITIAL: 'initial',
  IS_OPEN_UPI_CARD: 'isOpenUpiCard',
  IS_OPEN_BANK_ACCOUNT: 'isOpenBankAccount',
  PAYMENT_PROCESSING: 'PaymentProcessing',
  CONFIRM_PAYMENT_PROCESSING: 'confirmPaymentProcessing',
  SUCCESS_PAYMENT_PROCESSING: 'successPaymentProcessing',
  FAILED_PAYMENT_PROCESSING: 'failedPaymentProcessing',
  INITIAL_PAYMENT_METHOD_AVALIABLE: 'initialPaymentMethodAvaliable',
  INITIAL_PAYMENT_CONFIRM_SCREEN_METHOD_AVALIABLE: 'initialPaymentConfrimScreen',
  INITIAL_WITHDRAWAL_CARD: 'initialWithdrawalCard',
  EDIT_WITHDRAWAL_AMOUNT: 'editWithdrawalAmount',
}

export const PAYOUT_COUNT_TYPES = {
  PENDING_PAYOUT: 'pendingPayouts',
  REJECTED_PAYOUT: 'failedPayouts',
  APPROVED_PAYOUT: 'approvedPayouts',
  TOTAL_PAYOUT: 'totalPayouts'
}
